import { useCallback, useState } from 'react'

const useToggle = (initialState?: boolean) => {
	const [state, setState] = useState(!!initialState)
	const toggle = useCallback(() => setState(previousState => !previousState), [])
	return [state, toggle, setState] as const
}

export { useToggle }
